module.exports = __webpack_public_path__ + "img/faceTipsBG.c93edb82.png";